import dayjs from 'dayjs';
import styles from './Table.module.scss';
import { useMemo } from 'react';

type DateCellProps = {
  user: UserPublicProfileExtended;
};

const DateCell = ({ user }: DateCellProps) => {
  const date = useMemo(() => {
    return dayjs(user.date_joined).format('DD/MM/YY hh:mm A');
  }, [user]);
  return (
    <div className={`${!user.is_active && styles.deactivated} ${styles.ellipsis}`} title={date}>
      {dayjs(user.date_joined).format('DD/MM/YY hh:mm A')}
    </div>
  );
};

export default DateCell;
